import { useEffect } from 'react';

export const useSmoothScroll = () => {
  useEffect(() => {
    // Use native CSS smooth scrolling instead of Lenis to avoid forced reflows
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);
};